import React, { useState, useEffect, useRef } from "react";
import MessageRedirect from "./MessageRedirect";
import MessageA3 from "./MessageA3";
import "./Redirect_Message_Payment.css";

const parsePaymentData = (data) => {
  if (!data) return {};

  try {
    return typeof data === "string" ? JSON.parse(data) : data;
  } catch (error) {
    console.error("❌ Error parsing redirect payment data:", error);
    return {};
  }
};

const PaymentLoader = ({ timer, message, showMessageBelow = false }) => {

  return (
    <div className="loaderContainer-payment">
      {!showMessageBelow && <div className="payment-message">{message}</div>}
      <div className="loader-wrapper-payment">
        <div className="loader-payment"></div>
      </div>
      {showMessageBelow && (
        <div className="payment-message payment-message--below">{message}</div>
      )}
      <div className="timer-text">Time remaining: {timer}s</div>
    </div>
  );
};

export default function Redirect_Message_Payment(props) {
  const { item, showPaymentLoader } = props;
  const paymentData = parsePaymentData(item?.data);
  const [timer, setTimer] = useState(10);
  const [messageIndex, setMessageIndex] = useState(0);
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);
  const wsRef = useRef(null);
  const timerRef = useRef(null);
  const [labelText, setLabelText] = useState(item?.text);
  // console.log('🔄 Component render - showPaymentLoader:', showPaymentLoader, 'timer:', timer);

  const messages = [
    "Processing... Please wait",
    "Still processing... Please wait a bit longer.",
    "Payment verification taking longer than usual. Please be patient.",
    "Almost there! Final verification in progress.",
    "Thank you for waiting. Processing will complete soon."
  ];

  const handleButtonClick = () => {
    console.log('🔘 Button clicked - triggering payment flow');
    // Trigger handleClick with tag to show loader
    props.handleClick(item?.code, item?.data, "Redirect_Message_Payment",item?.text);
  };

  // ISOLATED Timer test
  useEffect(() => {
    console.log('🔍 Timer useEffect triggered, showPaymentLoader:', showPaymentLoader);
    
    if (showPaymentLoader) {
      console.log('⏱️ Creating timer interval');
      
      let count = 0;
      const timerId = setInterval(() => {
        count++;
        // console.log('✅ TIMER TICK #', count, 'at', new Date().toLocaleTimeString());
        
        setTimer(prevTimer => {
          const newValue = prevTimer - 1;
          
          // Change message when timer resets
          if (newValue === 0) {
            setMessageIndex(prevIndex => {
              const newIndex = (prevIndex + 1) % messages.length;
              console.log('📝 Message changed to index:', newIndex, messages[newIndex]);
              return newIndex;
            });
            return 10;
          }
          
          return newValue;
        });
      }, 1000);
      
      // console.log('📎 Timer created with ID:', timerId);
      
      return () => {
        // console.log('🧹 Timer cleanup called for ID:', timerId);
        clearInterval(timerId);
      };
    } else {
      console.log('🚫 Timer not started - showPaymentLoader is false');
    }
  }, [showPaymentLoader]);

  // WebSocket useEffect
  useEffect(() => {
    if (showPaymentLoader && item.data) {
      console.log('🔗 Starting WebSocket only');
      
      try {
        const wsData = parsePaymentData(item.data);
        console.log('🔗 WebSocket URL:', wsData?.webSocketUrl);
        
        if (wsData?.webSocketUrl) {
          wsRef.current = new WebSocket(wsData.webSocketUrl);
          
          wsRef.current.onopen = () => {
            console.log('✅ WebSocket connected');
          };
          
          wsRef.current.onmessage = (event) => {
            console.log('📨 WebSocket response:', event.data);
            
            // Stop timer when response received
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
            
            try {
              const responseData = JSON.parse(event.data);
              console.log('📝 Parsed WebSocket response:', responseData);
              
              // Check for timeout message
              if (responseData?.timeout) {
                console.log('⏰ Timeout detected, showing timeout message');
                props.handleClick('100', responseData?.transactionId , "Remove",labelText )
                setShowTimeoutMessage(true);
                return;
              }
              
              if (responseData?.transMessage ) {
                props.handleClick('100', responseData?.transactionId , "Remove",labelText )
              }
            } catch (error) {
              console.error('❌ Error parsing WebSocket response:', error);
              props.handleClick(item.code, event.data);
            }
          };

          wsRef.current.onerror = (error) => {
            console.error('❌ WebSocket error:', error);
            if (timerRef.current) {
              clearInterval(timerRef.current);
            }
          };

          wsRef.current.onclose = () => {
            console.log('🔌 WebSocket closed');
          };
        }
      } catch (error) {
        console.error('❌ Error parsing WebSocket data:', error);
      }
      
      return () => {
        console.log('🧹 Cleaning up WebSocket');
        if (wsRef.current) {
          wsRef.current.close();
        }
      };
    }
  }, [showPaymentLoader, item.data]);



  if (showPaymentLoader) {
    // Show timeout message if timeout detected
    if (showTimeoutMessage) {
      return (
        <div className="timeout-message">
          <div className="timeout-icon">⏰</div>
          <div className="timeout-text">Timeout</div>
          <div className="timeout-description">Session expired. Please try again.</div>
        </div>
      );
    }
    
    // Show normal loader
    const headerText = paymentData?.headerText;
    const textInLoader = paymentData?.TextInLoader;

    return (
      <>
        {headerText && (
          <MessageA3
            item={{
              uiCommand: "A3",
              text: headerText,
            }}
          />
        )}
        <PaymentLoader
          timer={timer}
          message={textInLoader || messages[messageIndex]}
          showMessageBelow={Boolean(textInLoader)}
        />
      </>
    );
  }

  const modifiedProps = {
    ...props,
    handleClick: handleButtonClick,
    setTextOnClick: () => {}
  };

  return <MessageRedirect {...modifiedProps} />;
}
